import { Notify } from 'quasar';
import { ApiError } from 'src/error/customError/ApiError';
import { AuthError } from 'src/error/customError/AuthError';
import { report } from 'src/error/report';
import { i18n } from 'src/boot/i18n';
const { t } = i18n.global;
export const error = (e: any, message?: string): true => {
  console.error(e);
  let msg = '';
  if (e instanceof ApiError || e instanceof AuthError) {
    msg = e.message;
  }
  Notify.create({
    type: 'negative',
    message: message || msg || t('error.unknown'),
  });
  if (e instanceof AuthError || e instanceof ApiError) {
    report(e);
  }
  return true;
};
